import React from 'react';

// Path to the logo file on your project
import logo from './logo.png';

const Logo = () => (
	<img src={logo} alt="Logo" style={{ width: 180 }} />
);

export default Logo;